export class ProcessingStepsRow {
	public accountName: string;
	public caseId: string;
	public caseName: string;
	public stepCount: number;
	public stepName: string;
}
